import { JobPostingListItem } from '@openclassrooms/sdk-web';
import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const { useFind: useFindRecommendedJobPostings } = getCRUDHooks<JobPostingListItem>({
  entityName: 'userSupports',
  find: ({ userId, filters }) =>
    clientApi.getOCClient().helpers.user.users.id(userId).recommendedJobPostings.find(filters),
});

export {
  // eslint-disable-next-line import/prefer-default-export
  useFindRecommendedJobPostings,
};
